import { useState } from 'react';
import strings from 'strings';

import { hasRestrictionStatus, isRestrictionType, RESTRICTION_TYPES } from '../constants';

export const getRestrictionMenuItems = ({
  canRequestDoNotContact,
  canRequestDoNotEngage,
  onSelectRestriction
}) => [
  {
    title: strings.formatString(strings.inventoryProfiles.common.restriction.menuItem, {
      restriction: strings.inventoryProfiles.common.restriction.doNotContact
    }),
    action: () => onSelectRestriction(RESTRICTION_TYPES.doNotContact),
    visible: canRequestDoNotContact
  },
  {
    title: strings.formatString(strings.inventoryProfiles.common.restriction.menuItem, {
      restriction: strings.inventoryProfiles.common.restriction.doNotEngage
    }),
    action: () => onSelectRestriction(RESTRICTION_TYPES.doNotEngage),
    visible: canRequestDoNotEngage
  }
];

export const useProfileRestrictions = ({
  canRequestDoNotContact,
  canRequestDoNotEngage,
  entityTypeId,
  profileStatusId
} = {}) => {
  const [selectedRestrictionType, setSelectedRestrictionType] = useState(null);

  const closeRestrictionDrawer = () => setSelectedRestrictionType(null);
  const hasDoNotContactStatus = hasRestrictionStatus({
    entityTypeId,
    profileStatusId,
    restrictionType: RESTRICTION_TYPES.doNotContact
  });
  const hasDoNotEngageStatus = hasRestrictionStatus({
    entityTypeId,
    profileStatusId,
    restrictionType: RESTRICTION_TYPES.doNotEngage
  });

  return {
    drawerProps: {
      onClose: closeRestrictionDrawer,
      open: isRestrictionType(selectedRestrictionType),
      selectedRestrictionType
    },
    menuItems: getRestrictionMenuItems({
      canRequestDoNotContact: canRequestDoNotContact && !hasDoNotContactStatus,
      canRequestDoNotEngage:
        canRequestDoNotEngage && !hasDoNotContactStatus && !hasDoNotEngageStatus,
      onSelectRestriction: setSelectedRestrictionType
    })
  };
};
